import { render, staticRenderFns } from "./Genus.vue?vue&type=template&id=5bbab577&scoped=true&"
import script from "./Genus.vue?vue&type=script&lang=js&"
export * from "./Genus.vue?vue&type=script&lang=js&"
import style0 from "./Genus.vue?vue&type=style&index=0&id=5bbab577&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbab577",
  null
  
)

export default component.exports